import request from '@/utils/request'

export function adminLogin(data) {
  return request({
    url: '/api/admin/auth/login',
    method: 'post',
    data
  })
}

export function changePassword(data) {
  return request({
    url: '/api/admin/auth/change-password',
    method: 'post',
    data
  })
}
